import { createAction } from '../../../store.model';
import { ActionType } from '../focus-selector.action';
import { Column } from '../grid/experimental.grid';

export interface FocusSelectorSortFocuses {
    column: Column;
}

export const focusSelectorSortFocuses = createAction<
    ActionType,
    FocusSelectorSortFocuses
>(ActionType.COACHING_FOCUS_SELECTOR__SORT_FOCUSES);
